import React from 'react';
import { PlusIcon } from '../icons';
import './Comment.css';

const QUICK_EMOJIS = ['🙌', '😮', '❤️'];

export interface CommentReplyBarProps {
  /** Callback when the bar is clicked */
  onClick?: () => void;
  /** Callback when a quick emoji is tapped (receives the emoji string) */
  onEmojiClick?: (emoji: string) => void;
  /** Placeholder text (default: "Add a comment...") */
  placeholder?: string;
  /** Optional className */
  className?: string;
}

/**
 * CommentReplyBar – A tappable bar styled like an input field.
 * Links to the add-comment flow (not an actual input).
 */
export const CommentReplyBar: React.FC<CommentReplyBarProps> = ({
  onClick,
  onEmojiClick,
  placeholder = 'Send to chat...',
  className,
}) => {
  return (
    <button
      type="button"
      className={`comment-reply-bar ${className || ''}`}
      onClick={onClick}
    >
      <span className="comment-reply-bar__placeholder">{placeholder}</span>
      <div className="comment-reply-bar__actions">
        {QUICK_EMOJIS.map((emoji) => (
          <span
            key={emoji}
            className="comment-reply-bar__emoji"
            role="button"
            onClick={(e) => {
              if (onEmojiClick) {
                e.stopPropagation();
                onEmojiClick(emoji);
              }
            }}
          >
            {emoji}
          </span>
        ))}
        <span className="comment-reply-bar__plus">
          <PlusIcon size="xs" tone="lightGrey" style={{ width: 18, height: 18 }} />
        </span>
      </div>
    </button>
  );
};

export default CommentReplyBar;
